// Scripts librairies
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'

// Styles librairies
import '../../scss/components/photoswipe.scss'
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css'
import 'photoswipe/style.css'

const smallScreenPadding = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
}
const largeScreenPadding = {
  top: 30,
  bottom: 30,
  left: 0,
  right: 0
}
const lightbox = new PhotoSwipeLightbox({
  gallery: '.gallery',
  children: 'a',
  closeTitle: 'Fermer',
  zoomTitle: 'Zoomer',
  arrowPrevTitle: 'Image précédente',
  arrowNextTitle: 'Prochaine image',
  errorMsg: 'L\'image ne peut être chargée',
  indexIndicatorSep: ' / ',
  paddingFn: (viewportSize) => {
    return viewportSize.x < 576 ? smallScreenPadding : largeScreenPadding
  },
  pswpModule: PhotoSwipe
})
// eslint-disable-next-line no-unused-vars
const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
  mobileLayoutBreakpoint: 576,
  type: 'auto',
  captionContent: '.pswp-caption-content'
})
/* eslint-enable no-unused-vars */
lightbox.init()

/*
// Styles librairies
//import 'photoswipe/dist/photoswipe.css'
//import 'photoswipe/dist/default-skin/default-skin.css'
import '../../scss/components/photoswipe.scss'

// Scripts librairies
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'

// photoswipe init and adding popup
const popup = '' +
  '<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">' +
    '<div class="pswp__bg"></div>' +
    '<div class="pswp__scroll-wrap">' +
        '<div class="pswp__container">' +
            '<div class="pswp__item"></div>' +
            '<div class="pswp__item"></div>' +
            '<div class="pswp__item"></div>' +
        '</div>' +
        '<div class="pswp__ui pswp__ui--hidden">' +
            '<div class="pswp__top-bar">' +
                '<div class="pswp__counter"></div>' +
                '<button class="pswp__button pswp__button--close" title="Fermer (Echap)"></button>' +
                '<button class="pswp__button pswp__button--share" title="Partager"></button>' +
                '<button class="pswp__button pswp__button--fs" title="Plein écran / réduire"></button>' +
                '<button class="pswp__button pswp__button--zoom" title="Zoom +/-"></button>' +
                '<div class="pswp__preloader">' +
                    '<div class="pswp__preloader__icn">' +
                      '<div class="pswp__preloader__cut">' +
                        '<div class="pswp__preloader__donut"></div>' +
                      '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">' +
                '<div class="pswp__share-tooltip"></div>' +
            '</div>' +
            '<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">' +
            '</button>' +
            '<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">' +
            '</button>' +
            '<div class="pswp__caption">' +
                '<div class="pswp__caption__center"></div>' +
            '</div>' +
        '</div>' +
    '</div>' +
'</div>'
document.body.innerHTML += popup

// galeries
const initPhotoSwipeFromDOM = function (gallerySelector) {
  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  const parseThumbnailElements = function (el) {
    const thumbElements = el.childNodes
    const numNodes = thumbElements.length
    const items = []
    let figureEl
    let linkEl
    let size
    let item

    for (let i = 0; i < numNodes; i++) {
      figureEl = thumbElements[i] // <figure> element

      // include only element nodes (only figure elements)
      if (figureEl.nodeType !== 1 || (figureEl.tagName && figureEl.tagName.toUpperCase() !== 'FIGURE')) {
        continue
      }

      // linkEl = figureEl.children[0] // <a> element
      linkEl = figureEl.getElementsByTagName('a')[0] // first <a> element inside the element
      size = linkEl.getAttribute('data-size').split('x')

      // create slide object
      item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      }

      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML
      }

      if (linkEl.children.length > 0) {
        // <img> thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src')
      }

      item.el = figureEl // save link to element for getThumbBoundsFn
      items.push(item)
    }

    return items
  }

  // find nearest parent element
  const closest = function closest (el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn))
  }

  // triggers when user clicks on thumbnail
  const onThumbnailsClick = function (e) {
    e = e || window.event
    e.preventDefault ? e.preventDefault() : e.returnValue = false

    const eTarget = e.target || e.srcElement

    // find root element of slide
    const clickedListItem = closest(eTarget, function (el) {
      return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
    })

    if (!clickedListItem) {
      return
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    const clickedGallery = clickedListItem.parentNode
    // const clickedGallery = clickedListItem.closest('.gallery')
    const childNodes = clickedListItem.parentNode.childNodes
    const numChildNodes = childNodes.length
    let nodeIndex = 0
    let index

    for (let i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1 || (childNodes[i].tagName && childNodes[i].tagName.toUpperCase() !== 'FIGURE')) {
        continue
      }
      if (childNodes[i] === clickedListItem) {
        index = nodeIndex
        break
      }
      nodeIndex++
    }

    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery)
    }
    return false
  }

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  const photoswipeParseHash = function () {
    const hash = window.location.hash.substring(1)
    const params = {}

    if (hash.length < 5) {
      return params
    }

    const vars = hash.split('&')
    for (let i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue
      }
      const pair = vars[i].split('=')
      if (pair.length < 2) {
        continue
      }
      params[pair[0]] = pair[1]
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10)
    }

    return params
  }

  const openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
    const pswpElement = document.querySelectorAll('.pswp')[0]
    const items = parseThumbnailElements(galleryElement)
    // define options (if needed)
    const options = {
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      getThumbBoundsFn: function (index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        const thumbnail = items[index].el.getElementsByTagName('img')[0] // find thumbnail
        // console.log(items[index].el)
        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
        const rect = thumbnail.getBoundingClientRect()
        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
      },
      bgOpacity: 0.75,
      showHideOpacity: true,
      shareButtons: [
        { id: 'facebook', label: 'Partager sur Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' },
        { id: 'twitter', label: 'Tweeter', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' },
        { id: 'pinterest', label: 'Pin it', url: 'https://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}' }
      ]
    }

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (let j = 0; j < items.length; j++) {
          if (items[j].pid === index) {
            options.index = j
            break
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1
      }
    } else {
      options.index = parseInt(index, 10)
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0
    }

    // Pass data to PhotoSwipe and initialize it
    const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUIDefault, items, options)
    gallery.init()
  }

  // loop through all gallery elements and bind events
  const galleryElements = document.querySelectorAll(gallerySelector)

  for (let i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1)
    galleryElements[i].onclick = onThumbnailsClick
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  const hashData = photoswipeParseHash()
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
  }
}

// execute above function
initPhotoSwipeFromDOM('.gallery')

*/
